/* eslint-disable @typescript-eslint/no-unsafe-return */
import { i18n } from 'src/boot/i18n';
import stringUtil from 'src/utils/string';
import { isUndefinedOrNull } from 'src/utils/general';


export default {
  mixins: [stringUtil],
  methods: {
    displayFieldLabel(row, prefix = '', show_translation_key = true) {
      let label = '';
      try {
        if (isUndefinedOrNull(row)) {
          return label;
        }
        let hide_label = !row.hide_label ? false : row.hide_label;
        let translation_key = row.translation_key
          || row.field_name
          || row.document_name
          || row.document_key;
        let alt_label = !row.alt_label ? false : row.alt_label;

        if (alt_label) {
          hide_label = false;
          translation_key = alt_label;
        }

        translation_key = prefix + translation_key;
        const title = !row.title ? '' : row.title;
        const translation = this.translateLabel(translation_key);

        label = '';

        if (hide_label === false) {
          label = title;
        }

        if (translation !== translation_key) {
          label = translation;
        }

        if (!label && show_translation_key) {
          label = row.field_name || row.document_name || row.document_key;
        }
      } catch (err) {
        logError(err);
      }
      return label;
    },
    displayFieldLabelFor2a(row) {
      // right now on old view we are only hidding label for VAT & AMOUNTS
      // According Kerstin Mende we need to display the labels foe this section

      row.hide_label = false;
      return this.displayFieldLabel(row);
    },
    displayFieldLabelForMedi(row) {
      return this.displayFieldLabel(row);
    },
    translateLabel(translation_key) {
      let translation = '';
      try {
        if (!translation_key) {
          return translation;
        }

        // Try the full key
        translation = i18n.t(translation_key);
        if (translation != translation_key) {
          return translation;
        }

        // Try lowercase
        if (
          i18n.t(translation_key.toLowerCase()) != translation_key.toLowerCase()
        ) {
          return i18n.t(translation_key.toLowerCase());
        }

        console.log('******************************************************************************')
        console.log('Key needs a new translation ', translation_key)
        console.log('******************************************************************************')

        return translation_key;
      } catch (err) {
        logError(err);
      }
      return translation;
    },
    getLabelForFormBuilder(row, prefix = '', show_translation_key = false) {
      if (isUndefinedOrNull(row)) {
        return '';
      }

      let label = this.displayFieldLabel(row, prefix, show_translation_key);
      return label ? label : String(row.label ? row.label : '');
    },

    getFieldLabelFromAllPrefixes(row) {
      let label = this.displayFieldLabel(row);
      if (!label) {
        label = this.displayFieldLabel(row);
      }
      if (!label) {
        label = this.getLabelForFormBuilder(row, '', true);
      }
      return label ? label : String(row.label);
    },
    getLabelToDisplay(item) {
      let translation_key = item.translation_key;

      if (!translation_key) {
        translation_key = item.column_name ? item.column_name : item.name;
      }

      let label = this.translateLabel(translation_key);

      if (!label || label == translation_key) {
        label = item.title;
      }

      return label;
    },
    keyFormatter(key) {
      //remove _ from key
      if (!key) {
        return;
      }
      return key.replace(/_/g, ' ');
    },
    formateTextAndTranlate(str, strToSearch, replacement) {
      if (!str) {
        return '';
      }
      let lable = str.toLowerCase();
      if (strToSearch && replacement) {
        lable = this.stringReplaceWithString(lable, strToSearch, replacement);
      }

      let translatedLabel = this.translateLabel(lable);

      if (translatedLabel == lable) {
        translatedLabel = this.formatText(lable);
      }

      return translatedLabel;
    },
  },
};
